module.exports = __webpack_public_path__ + "elevate.1TPGZpRJ.svg";